import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone, CalendarCheck } from "lucide-react";
import { PHONE_TEL } from "@/data/site";

const MobileCTA = () => (
  <motion.div
    data-testid="mobile-sticky-cta"
    initial={{ y: 90 }}
    animate={{ y: 0 }}
    transition={{ delay: 1.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 border-t border-white/10 bg-bear-ink/95 backdrop-blur-xl lg:hidden"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    <a
      href={PHONE_TEL}
      data-testid="mobile-cta-call"
      className="flex items-center justify-center gap-2 bg-bear-red py-4 font-head text-sm font-bold uppercase tracking-wider text-white active:bg-red-700"
    >
      <Phone className="h-4 w-4" />
      Call Now
    </a>
    <Link
      to="/contact"
      data-testid="mobile-cta-schedule"
      className="flex items-center justify-center gap-2 py-4 font-head text-sm font-bold uppercase tracking-wider text-bear-cyan active:bg-white/5"
    >
      <CalendarCheck className="h-4 w-4" />
      Schedule
    </Link>
  </motion.div>
);

export default MobileCTA;
